const routes = [
  { path: '/world', route: 'world' },
  { path: '/country', route: 'country' },
];

export default routes;